module.exports = __webpack_public_path__ + "img/cooperation.fc8ddba1.png";